<div class="mb-3" *ngIf="registerForm.controls['email'].hasError('emailExists')">
    <app-custom-toast [toastTitle]="toastTitle" [toastIconStyle]="toastIcon" [toastStyle]="toastbg"
        [showToast]="registerForm.controls['email'].hasError('emailExists')">
        <p class="m-0">
            Please <p-button [link]="true" label="log in" class="inline underline-offset-3"
                styleClass="py-1 px-0 min-h-0 h-auto underline text-orange-900 hover:text-orange-800 custom-bold text-base"
                (click)="navigateToLogin('toast')"></p-button> to continue or <p-button [link]="true"
                label="reset your password" class="inline underline-offset-3"
                styleClass="py-1 px-0 min-h-0 h-auto underline text-orange-900 hover:text-orange-800 custom-bold text-base"
                (click)="navigateToForgotPassword('toast')"></p-button>.
        </p>
    </app-custom-toast>
</div>
<p-card styleClass="my-2" [header]="cardHeader">
    <p class="m-0 mt-2 mb-2">{{cardSubtitle}}</p>
    @if(!isVivr){
        <div class="mt-2" [ngClass]="{ 'overflow-y-auto max-h-30rem': planMultiple && planMultiple.length > 10 }">
            <div *ngFor="let plan of planMultiple; let i = index; trackBy: trackByIndex">
                <div class=" mt-4 mb-3">
                    <p-panel class="p-0 m-0" #panel aria-label="Plans panel" [toggleButtonProps]="{
                        'ariaLabel': 'Plan panel toggle button ' + (i + 1),
                      }" [toggleable]="planMultiple.length > 1" [collapsed]="planMultiple.length > 1"
                        collapseIcon="pi pi-angle-down" expandIcon="pi pi-angle-up" class="create-account-plan-panel">
                        <ng-template pTemplate="header">
                            <div class="w-full" (click)="panel.toggle($event)">
                                <p class="p-0 m-0 text-slate-800 custom-bold">Plan: {{ plan.filedClientSpecificProductName |
                                    titlecase }}</p>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <div class="create-account-mult-plan">
                                <p class="p-1 m-0 text-slate-800">Number: {{ plan.contractNumber | maskNumber }}</p>
                                <p class="p-1 m-0 text-slate-800">
                                    {{ plan.propertyAddr1 }}
                                </p>
                                <p class="p-1 m-0 text-slate-800">
                                    {{ plan.propertyCity }},
                                    {{ plan.propertyStateCode }}
                                    {{ plan.propertyZipCode }}
                                </p>
                            </div>
                        </ng-template>
                    </p-panel>
                </div>
            </div>
        </div>
    }
    <div class="flex pt-3">
        <form [formGroup]="registerForm" class="w-full">
            <div class="p-fieldset mb-4">
                <label id="email-label" for="email">Email</label>
                <div *ngIf="registerForm.controls['email'].errors?.['required']" class="required">
                    <span class="bg-slate-100">Required</span>
                </div>
                <div *ngIf="registerForm.controls['email'].touched && registerForm.controls['email'].errors?.['required']"
                    class="required text-orange-900">
                    <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                </div>
                <p-iconfield class="flex w-full">
                    <input id="email" type="text" pInputText formControlName="email" data-auto-id="register-email"
                        aria-labelledby="email-label" class="w-full">
                    <p-inputicon *ngIf="isCheckingEmail" styleClass="pi pi-spinner pi-spin text-lg text-slate-800" />
                </p-iconfield>

                <div *ngIf="registerForm.controls['email'].invalid && registerForm.controls['email'].touched">
                    <small *ngIf="registerForm.controls['email'].hasError('required')" class="mt-1 text-rose-600">
                        Email is required.
                    </small>
                    <small *ngIf="registerForm.controls['email'].hasError('email')" class="mt-1 text-rose-600">
                        This is not a valid email.
                    </small>
                    <small *ngIf="registerForm.controls['email'].hasError('emailExists')" class="mt-1 text-rose-600">
                        An account with this email already exists. Please try <p-button [link]="true" label="logging in"
                            class="inline underline-offset-3"
                            styleClass="py-1 px-0 min-h-0 h-auto underline text-rose-600 hover:text-rose-900 font-normal text-xs"
                            (click)="navigateToLogin('error')"></p-button> with this email address.
                    </small>
                </div>
            </div>
            <div class="p-fieldset mb-4">
                <label id="password-label" for="password">Password</label>
                <div *ngIf="registerForm.controls['password'].errors?.['required']" class="required">
                    <span class="bg-slate-100">Required</span>
                </div>
                <div *ngIf="registerForm.controls['password'].touched && registerForm.controls['password'].invalid"
                    class="required text-orange-900">
                    <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                </div>
                <p-password id="password" formControlName="password" [toggleMask]="true" data-auto-id="password"
                    aria-labelledby="password-label" styleClass="w-full" inputStyleClass="w-full">
                    <ng-template #header>
                        <div class="font-semibold text-sm mb-4">Pick a password</div>
                    </ng-template>
                    <ng-template #footer>
                        <p-divider />
                        <ul class="list-none pl-2 ml-2">
                            <app-list-item [isSuccess]="hasMinLength">Minimum 8 characters</app-list-item>
                            <app-list-item [isSuccess]="hasLowercase">At least one lowercase</app-list-item>
                            <app-list-item [isSuccess]="hasUppercase">At least one uppercase</app-list-item>
                            <app-list-item [isSuccess]="hasNumber">At least one number</app-list-item>
                            <app-list-item [isSuccess]="hasSpecialChar">At least one special character
                                (&#64;$!%*?&)</app-list-item>
                        </ul>
                    </ng-template>
                </p-password>
                <small class="mt-1 text-slate-600">
                    At least 1 letter, a number or symbol, at least 8 characters.
                </small>
            </div>

            <div class="p-fieldset mb-4">
                <label id="confirm-password-label" for="confirm-password">Confirm Password</label>
                <div *ngIf="registerForm.controls['confirmPassword'].errors?.['required']" class="required">
                    <span class="bg-slate-100">Required</span>
                </div>
                <div *ngIf="registerForm.controls['confirmPassword'].touched && registerForm.controls['confirmPassword'].invalid"
                    class="required text-orange-900">
                    <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
                </div>
                <p-password id="confirm-password" formControlName="confirmPassword" [toggleMask]="true"
                    data-auto-id="confirm-password" aria-labelledby="confirm-password-label" [feedback]="false"
                    styleClass="w-full" inputStyleClass="w-full" />
                <div *ngIf="registerForm.controls['confirmPassword'].touched">
                    <small *ngIf="registerForm.hasError('passwordMismatch')" class="mt-1 text-rose-600">Passwords must
                        match</small>
                </div>
            </div>

            <p class="text-slate-600 text-xs m-0">By selecting Create account, you agree to our User Agreement and
                acknowledge reading our User Privacy Notice.</p>

            <div class="flex flex-column mt-4">
                <p-button [disabled]="registerForm.invalid || loading" [rounded]="true"
                    data-auto-id="create-account-button" (click)="createAccount()"
                    class="flex align-items-center justify-content-center w-full"
                    [styleClass]="isVivr ? 'text-base w-12 sm:w-7 md:w-5' :'w-full'">
                    <ng-container *ngIf="loading">
                        <i class="pi pi-spin pi-spinner"></i>&nbsp;Creating Account
                    </ng-container>
                    <ng-container *ngIf="!loading"> Create Account </ng-container>
                </p-button>
                @if (!isVivr) {
                    <p-button [rounded]="true" [link]="true" label="Forgot your password?" severity="secondary"
                        data-auto-id="forgot-password-link" (click)="navigateToForgotPassword('links')"
                        class="flex align-items-center justify-content-center w-full underline-offset-3"
                        styleClass="w-full white-space-nowrap underline pr-0 mt-2"></p-button>
                    <div class="flex flex-row align-items-center justify-content-center">
                        <p class="m-0 white-space-nowrap">Already have an account?</p>
                        <p-button [rounded]="true" label="Log in instead" [link]="true" severity="primary"
                            data-auto-id="login-button" (click)="navigateToLogin('links')"
                            class="flex align-items-center justify-content-center white-space-nowrap underline-offset-3"
                            styleClass="underline p-1">
                        </p-button>
                    </div>
                }
            </div>
        </form>
    </div>
</p-card>
@if(!isVivr){
    <div class="pt-4">
        <p-button label="Back" [rounded]="true" severity="secondary" variant="outlined" data-auto-id="back-button"
            (click)="back()" class="flex align-items-center justify-content-center w-full"
            styleClass="w-full shadow-button bg-white" />
    </div>
}